<template>
  <RouterView />
  <div
    id="alert-box"
    class="fixed bottom-0 left-0 right-0 z-50 mx-auto h-fit px-1"
  />
</template>
